import { format, parseISO, isValid, isDate } from 'date-fns'

export function dateFormat (date: number | Date | string, template='yyyy-MM-dd') {
  if (typeof date === 'string') {
    const parsed = parseISO(date)
    if (!isValid(parsed)) {
      return ''
    }
    return format(parsed, template)
  }
  if (!isValid(date)) {
    return ''
  }
  return format(date, template)
}
